<template>
    <FilterPage
        title="Festivals"
        subtitle="Lieux de création"
        v-on="$listeners"
        @reset="handleReset"
    >
        <CheckboxesCriteria
            v-model="value.venues.festivalArtisticFields"
            :options="checkboxesOptions"
            @change="handleChanged"
            ref="checkboxes"
        />
    </FilterPage>
</template>

<script>
    import { BFormCheckbox, BCollapse } from 'bootstrap-vue';
    import FilterPage from "../../../FilterPage.vue";
    import CheckboxesCriteria from "../../criterias/Checkboxes.vue";

    export default {
        components: {
            FilterPage,
            BFormCheckbox,
            BCollapse,
            CheckboxesCriteria,
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            checkboxesOptions() {
                return this.criterias.venues.festivalArtisticFields;
            },
        },
        methods: {
            handleChanged() {
                this.$emit('input', { ...this.value });
            },
            handleReset() {
                this.$refs.checkboxes.reset();
            },
        }
    }
</script>
